var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.visible)?_c('Notification',{attrs:{"icon":_vm.options.icon,"special":_vm.options.special,"message":_vm.options.message,"header":_vm.options.header,"color":_vm.notificationColor},on:{"close":_vm.close}}):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }